// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root{--mpm-section-navbar-height: 52px}.model-page-header{height:52px;display:flex;justify-content:space-between;align-items:center}.model-page-header .ds-section-tabs-wrapper{margin-top:12px}.header-tabs-wrapper{display:flex;justify-content:space-between}.header-tabs-wrapper>button{width:84px;height:26px}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
